<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col md:w-1/2 w-full">
        <h2> {{ $t('fidelization.DishGroup') }}</h2>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="text-right" >
          <vs-button @click="popupNewDishGroup=true" color="primary" type="border">{{ $t('fidelization.DishGroupNew') }}</vs-button>
          <vs-popup :title="$t('fidelization.DishGroupNew')" class="popup-w-900" :active.sync="popupNewDishGroup">
            <new-dish-group ref="newDishGroupModal"></new-dish-group>
          </vs-popup>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
          <table-data-grid :data="itemsDataGrid" :dataColumns="dataColumns" link="dishGroup" >
            <template v-slot:actions="slotProps" >
              <div class="dropdown-button-container">

                  <vs-button class="btnx" type="filled" color="primary" @click="seeDishGroup(slotProps.item.id,slotProps.item.dishes)">
                    {{ $t('Ver') }}
                  </vs-button>

                <vs-dropdown vs-trigger-click>
                  <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
                  <vs-dropdown-menu>
                    <ul style="min-width: 12rem">
                      <li>
                        <router-link :to="slotProps.item.linkAssign" target="_blank" class="cursor-pointer py-3 px-4 block hover:bg-primary hover:text-white w-full" >
                          <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                          <span class="ml-2">{{ $t('fidelization.DishGroupAssign') }}</span>
                        </router-link>
                      </li>

                      <vs-divider class="m-1" />
                      <li>
                        <span
                          @click="editDishGroup(slotProps.item.id)"
                          class="cursor-pointer py-3 px-4 block text-primary hover:bg-primary hover:text-white w-full"
                        >
                          <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                          <span class="ml-2">{{ $t('Editar') }}</span>
                        </span>
                      </li>
                      <vs-divider class="m-1" />
                      <li>
                        <span @click="deleteModalDishGroup(slotProps.item.id, slotProps.item.name)" class="cursor-pointer py-3 px-4 block hover:bg-danger text-danger hover:text-white w-full" >
                          <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                          <span class="ml-2">{{ $t('Eliminar') }}</span>
                        </span>
                      </li>
                    </ul>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </template>
          </table-data-grid>
          <vs-popup :title="$t('fidelization.DishGroupEdit')" class="popup-w-900" v-if="openModal" :active.sync="popupEditDishGroup">

            <edit-dish-group
            v-if="openModal"
              :dishGroup="dishGroup"

            />
          </vs-popup>

          <vs-popup :title="$t('fidelization.DishGroupDetail')" class="popup-w-900" :active.sync="popupSeeDishGroup">
            <public-dish-group
              :dish_group="dishGroup"


            />
          </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
  import NewDishGroup from '@/views/NewDishGroup'
  import EditDishGroup from '@/views/EditDishGroup'
  import PublicDishGroup from '@/components/DishGroups/PublicDishGroup'
    import TableDataGrid from '../components/TableDataGrid';
    import GenerateQr from '../components/GenerateQr';
    import {mapActions, mapGetters,mapMutations} from 'vuex';

    export default {
        components: {
            TableDataGrid,
            GenerateQr,
           NewDishGroup,
           EditDishGroup,
           PublicDishGroup

        },
        data () {
            return {
                dialog: false,
                dataColumns: [
                    {caption: 'ID', visible: false},
                    {dataField: 'name', caption: this.$t('Nombre'), visible: true, width: 50},
                    {dataField:'dishes', caption:this.$t('fidelization.DishGroupProducts'),visible:true, width:400},
                    {caption: 'Slug', dataType: 'text', visible: false},
                    {caption: 'linkEdit', visible: false},
                    {caption: 'linkAssign', visible: false},
                    {visible: false}
                ]
            }
        },
        created () {
            this.refreshDishGroup({language: this.language});
        },
        computed: {
            ...mapGetters({
                languages: 'getLanguages',
                itemsDishGroups: 'getDishGroups',
                dishGroup:'getDishGroup',
                language: 'getCurrentLanguage'
            }),
            popupEditDishGroup: {
                get ()    { return this.$store.getters.getpopupEditDishGroup },
                set (val) { this.$store.commit('setpopupEditDishGroup', val) }
            },
            popupNewDishGroup: {
                get ()    { return this.$store.getters.getpopupNewDishGroup },
                set (val) {
                  this.$refs.newDishGroupModal.resetForm();
                  this.$store.commit('setpopupNewDishGroup', val)
                  }
            },
            popupSeeDishGroup: {
                get ()    { return this.$store.getters.getpopupSeeDishGroup },
                set (val) { this.$store.commit('setpopupSeeDishGroup', val) }
            },
            openModal () {
                if (this.popupEditDishGroup === true && Object.keys(this.dishGroup).length > 0) {
                    return true;
                }
                return false;
            },

            itemsDataGrid () {
                const items = this.itemsDishGroups;
                const results = [];
                const aux = this;

                items.forEach(function (item, index) {
                  const dishesArray = new Array()

                   if (item.dishes.length > 0) {
                    item.dishes.forEach(function (i,index) {
                      dishesArray.push(item.dishes[index].name);
                    });
                  }
                  if (dishesArray.length > 0){
                    var dishesString =""
                    for (var i=0;i<dishesArray.length; i++){
                      if(i==dishesArray.length-1){
                        dishesString+=dishesArray[i]
                      }
                      else{
                        dishesString+=dishesArray[i]+", "
                      }

                    }

                    results[index] = {
                       id: items[index].id,
                       name: items[index].name,
                       dishes:dishesString,
                       linkAssign:`dish-groups/assign/${  items[index].id}`
                    };
                  }
                  else{
                    results[index] = {
                       id: items[index].id,
                       name: items[index].name,
                       dishes:'No hay productos asignados todavía',
                       linkAssign:`dish-groups/assign/${  items[index].id}`
                    };

                  }

                }, items)
                return results
            }
        },
        methods: {
            ...mapActions({
                refreshDishGroup: 'refreshDishGroup',
                deleteDishGroup: 'deleteDishGroup',
                getDishGroup:'getDishGroup'
            }),
            ...mapMutations({
                setDishGroup: 'setItemDishGroup',
                loading: 'loading',
            }),
            editDishGroup (id) {
                this.setDishGroup({});
                this.getDishGroup({id:id, language: this.language});

                this.popupEditDishGroup = true;
            },
            seeDishGroup(id) {
                 this.setDishGroup({});
                this.getDishGroup({id:id, language: this.language});
                this.popupSeeDishGroup = true;
            },

            deleteModalDishGroup (id, name) {
                const aux = this;

                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('fidelization.DishGroupDelete'),
                    text: this.$t('fidelization.DishGroupDeleteConfirm', {nombre: name}),
                    acceptText: this.$t('Aceptar'),
                    cancelText: this.$t('Cancelar'),
                    accept () {
                        aux.deleteDishGroup(id)
                    }
                })
            },
        }
    }

</script>

<style>

</style>
